import {
    useEffect,
    useState,
} from 'react'
import isEmpty from 'lodash/isEmpty'

import FormWithControls from 'app/shared-components/FormWithControls'
import request from 'app/requests/ServiceCenter/ServiceCenter.requests'
import StatusHandler from 'app/shared-components/StatusHandler'
import {
    StorageType,
} from 'app/enums/label.enums'

import useGetServiceCenterById from '../hooks/useGetServiceCenterById'
import {
    ServiceCenterFormType,
} from '../serviceCenters.types'
import fields from './dailyOpsDataUpdate.fields'
import useStyles from './dailyOpsDataUpdate.styles'

const DailyOpsDataUpdate = ({
    id,
}: Readonly<{ id: number }>) => {
    const {
        classes,
    } = useStyles()

    const [
        value,
        setValue,
    ] = useState<Partial<ServiceCenterFormType>>()

    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
        invalidate,
    } = useGetServiceCenterById(id)

    useEffect(() => {
        if (data) {
            setValue({
                orderSelectionDelay: data.orderSelectionDelay,
                maxTrucksPerDay: data.maxTrucksPerDay,
                processingThroughput: data.processingThroughput,
                productMetrics: data.productMetrics,
                storages: data.storages,
            })
        }
    }, [data])

    const modifyDataBeforeSend = (
        dataForm: ServiceCenterFormType,
    ): Partial<ServiceCenterFormType> => {
        return {
            ...dataForm,
            productMetrics: dataForm?.productMetrics?.filter((item) => {
                return !isEmpty(item) && Object.values(item).every((el) => {
                    return Boolean(el) || el === 0
                })
            }),
            storages: dataForm?.storages?.filter((storage) => {
                return !isEmpty(storage)
                    && (
                        (storage.storageType === StorageType.DRY
                            && Boolean(storage.storageCapacity))
                        || Object.values(storage).every((el) => {
                            return Boolean(el)
                        }))
            }),
        }
    }

    return (
        <StatusHandler
            isError={isError}
            isFetching={isFetching}
            error={error}
            isSuccess={isDataReady}
        >
            <FormWithControls
                onSuccess={invalidate}
                value={value}
                setExternalValue={setValue}
                name={request.domainName}
                fields={fields}
                requestParams={request.opsUpdate({
                    id: data?.id,
                })}
                modifyDataBeforeSend={modifyDataBeforeSend}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                exists
            />
        </StatusHandler>
    )
}

export default DailyOpsDataUpdate
